import Player from 'video.js/dist/types/player';

import { setupProgressSpacing } from '../utils/progressSpacingUtils';
import { createSkipButtons } from '../utils/skipButtonsUtils';
import { createVolumeControl } from '../utils/volumeControlUtils';

export const setupCustomControls = (player: Player) => {
  const controlBar = player.getChild('ControlBar');
  if (!controlBar) return;

  const playButton = controlBar.el().querySelector('.vjs-play-control');
  if (!playButton || !playButton.parentNode) return;

  createSkipButtons(player, controlBar, playButton);

  const volumeFullscreenGroup = document.createElement('div');
  volumeFullscreenGroup.className = 'vjs-volume-fullscreen-group';

  const defaultVolumePanel = controlBar.el().querySelector('.vjs-volume-panel');
  if (defaultVolumePanel) {
    defaultVolumePanel.remove();
  }

  const volumeControl = createVolumeControl(player);
  volumeFullscreenGroup.appendChild(volumeControl);

  const fullscreenControl = controlBar.el().querySelector('.vjs-fullscreen-control');
  if (fullscreenControl) volumeFullscreenGroup.appendChild(fullscreenControl);

  controlBar.el().appendChild(volumeFullscreenGroup);

  setupProgressSpacing(player);
};
